import Link from 'next/link';
import classNames from 'classnames';

import { Svg } from '@components/svg/Svg';

import styles from './navigation-fullscreen-header.module.scss';
import { NavigationAddOn } from './NavigationAddOn';

interface NavigationFullscreenHeaderProps {
	className?: string;
}

export const NavigationFullscreenHeader = ({
	className,
}: NavigationFullscreenHeaderProps) => {
	return (
		<div
			className={classNames(className, styles['navigation-fullscreen-header'])}
		>
			<ul
				className={classNames(
					styles['navigation-fullscreen-header__anchor-list'],
					'list-unstyled',
				)}
			>
				<li className={styles['navigation-fullscreen-header__logo']} key="logo">
					<Link aria-label="Homepage" href="/">
						<Svg id="logo" />
					</Link>
				</li>
				<li
					className={classNames(
						styles['navigation-fullscreen-header__membership-anchor'],
					)}
					key="membership-anchor"
				/>
				<li
					className={styles['navigation-fullscreen-header__account']}
					key="account"
				>
					<NavigationAddOn />
				</li>
			</ul>
		</div>
	);
};
